import Swal from 'sweetalert2'
import { quickReplyHtml } from './quickReplyHtml'
import { lang } from '../../assets/lang'
import { addClassToAll, sweetAlertCommonParams, createSelect2DynamicOption, selectedOptionsTextArray } from '../../utils/functions'

export const quickReplyModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.quick_reply_modal_title,
    html: quickReplyHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })
      
      const replyType = $('#quick-reply-type')
      const buttonTextGroup = $('#quick-reply-button-text-group')
      const postbackGroup = $('#quick-reply-postback-group')
      
      const replyTypeValue = oldData.replyType || ''
      const buttonTextValue = oldData.buttonText || ''
      const postbackIdValue = oldData.postbackId || ''

      replyType.val(replyTypeValue).trigger('change')

      var page_table_id = window.xitFlowBuilderData.page_table_id
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
      var base_url = window.xitFlowBuilderData.base_url
      const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

      const elementLabel = $('#new-button-choose-label')
      const elementLabelRemove = $('#new-button-remove-label')
      createSelect2DynamicOption(elementLabel)
      createSelect2DynamicOption(elementLabelRemove)
      const onlyForSendMessage = $('.only-for-send-message')
      const buttonWebhookUrl = $('#new-button-webhook-url')
      buttonWebhookUrl.val(oldData.buttonWebhookUrl || '')
      
      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_dropdown_postback',
        dataType: 'JSON',
        data: { page_table_id, instagram_bot_addon },
        success:function(response){
          $("#quick-reply-postback").html(response.dropdown_str);
          if ('post_back' === replyTypeValue) {
            $('#quick-reply-postback').val(postbackIdValue).trigger('change')
          }
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'new_postback', instagram_bot_addon },
        success:function(response) {
          $("#new-button-choose-label").html(response.label_dropdown);
          $("#new-button-remove-label").html(response.label_dropdown);
          $("#new-button-choose-sequence").html(response.drip_dropdown);
          $("#new-button-remove-sequence").html(response.drip_dropdown_remove);

          $('#new-button-choose-label').val(oldData.labelIds || '').trigger('change')
          $('#new-button-remove-label').val(oldData.labelIdsRemove || '').trigger('change')

          if (isSequenceAddonAvailable) {
            $('#new-button-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
            $('#new-button-remove-sequence').val(oldData.sequenceIdValueRemove || '').trigger('change')
          }
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_team_and_user',
        dataType: 'JSON',
        data: { page_table_id },
        success:function(response) {
          $("#new-button-conversation-user").html(response.team_dropdown);
          $('#new-button-conversation-user').val(oldData.conversationUserId || '').trigger('change')
          $("#new-button-conversation-group").html(response.role_dropdown);
          $('#new-button-conversation-group').val(oldData.conversationGroupId || '').trigger('change')
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_google_sheets',
        dataType: 'JSON',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-CSRF-TOKEN', window.xitFlowBuilderData.csrf_token);
        },
        success:function(response) {
          $("#quickreply-google-sheets").html(response.googleSheets);
          $('#quickreply-google-sheets').val(oldData.googleSheets || '').trigger('change')
        }
      })

      if ('post_back' === replyTypeValue) {
        $('#quick-reply-button-text').val(buttonTextValue)
        $('#quick-reply-postback').val(postbackIdValue).trigger('change')
        buttonTextGroup.removeClass('d-none')
        postbackGroup.removeClass('d-none')
      } else if ('new_post_back' === replyTypeValue) {
        $('#quick-reply-button-text').val(buttonTextValue)
        buttonTextGroup.removeClass('d-none')
        onlyForSendMessage.removeClass('d-none')
      }

      replyType.on('change', function(e) {
        const selectedType = e.target.value
        addClassToAll('d-none', '.button-onDemand-field')

        if(selectedType !== 'new_post_back')
        {
          $('#new-button-choose-sequence').val('').trigger('change')
        }

        if ('new_post_back' === selectedType) {
          postbackGroup.addClass('d-none')
          buttonTextGroup.removeClass('d-none')
          onlyForSendMessage.removeClass('d-none')
        } else if ('post_back' === selectedType) {
          // Display spinner before loading postback list
          Swal.showLoading()
          
          // Hides spinner after loading postback list
          Swal.hideLoading()

          buttonTextGroup.removeClass('d-none')
          postbackGroup.removeClass('d-none')

          // TODO
          // Load post back IDs and fill in select options
        } else {
          buttonTextGroup.addClass('d-none')
          postbackGroup.addClass('d-none')
          onlyForSendMessage.addClass('d-none')
        }
      })
    },

    preConfirm: () => {
      const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
      const replyType = $('#quick-reply-type')
      const buttonText = $('#quick-reply-button-text')
      const postback = $('#quick-reply-postback')
      const buttonWebhookUrl = $('#new-button-webhook-url').val()

      const replyTypeValue = replyType.val()
      
      if (! replyTypeValue) {
        Swal.showValidationMessage(lang.quick_reply_modal_msg_reply_type)
      }

      const data = {
        replyType: replyTypeValue,
        replyTypeText: $('#quick-reply-type option:selected').text(),
        buttonWebhookUrl: buttonWebhookUrl,
      }
      
      const buttonTextValue = buttonText.val()
      const postbackIdValue = postback.val()

      if ('post_back' === replyTypeValue) {
        if (! buttonTextValue) {
          Swal.showValidationMessage(lang.quick_reply_modal_msg_button_text)
        } else if (! postbackIdValue) {
          Swal.showValidationMessage(lang.quick_reply_modal_msg_postback_id)
        }

        data['replyType'] = 'post_back'
        data['buttonText'] = buttonTextValue
        data['postbackId'] = postbackIdValue
        data['postbackIdText'] = $('#quick-reply-postback option:selected').text()
      } else if ('new_post_back' === replyTypeValue) {
        if (! buttonTextValue) {
          Swal.showValidationMessage(lang.quick_reply_modal_msg_button_text)
        }

        data['buttonText'] = buttonTextValue
      }

      const labelIds = $('#new-button-choose-label').val()
      const labelIdTexts = $('#new-button-choose-label option:selected')      
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts) 
      data['labelIds'] = labelIds
      data['labelIdTextsArray'] = labelIdTextsArray

      const google_sheets = $('#quickreply-google-sheets').val()
      const google_sheets_text = $('#quickreply-google-sheets option:selected')      
      const google_sheets_array = selectedOptionsTextArray(google_sheets_text) 
      data['googleSheets'] = google_sheets
      data['googleSheetsArray'] = google_sheets_array

      const labelIdsRemove = $('#new-button-remove-label').val()
      const labelIdTextsRemove = $('#new-button-remove-label option:selected')      
      const labelIdTextsArrayRemove = selectedOptionsTextArray(labelIdTextsRemove) 
      data['labelIdsRemove'] = labelIdsRemove
      data['labelIdTextsArrayRemove'] = labelIdTextsArrayRemove
      
      if (isSequenceAddonAvailable) {
        const sequenceIdValue = $('#new-button-choose-sequence').val()
        const sequenceIdText = $('#new-button-choose-sequence option:selected').text()
        data['sequenceIdValue'] = sequenceIdValue
        data['sequenceIdText'] = sequenceIdText

        const sequenceIdValueRemove = $('#new-button-remove-sequence').val()
        const sequenceIdTextRemove = $('#new-button-remove-sequence option:selected').text()
        data['sequenceIdValueRemove'] = sequenceIdValueRemove
        data['sequenceIdTextRemove'] = sequenceIdTextRemove
      }

      const conversationGroupId = $('#new-button-conversation-group').val()
      const conversationGroupText = $('#new-button-conversation-group option:selected').text()
      data['conversationGroupId'] = conversationGroupId
      data['conversationGroupText'] = conversationGroupText

      const conversationUserId = $('#new-button-conversation-user').val()
      const conversationUserText = $('#new-button-conversation-user option:selected').text()
      data['conversationUserId'] = conversationUserId
      data['conversationUserText'] = conversationUserText

      return data
    },    
  })
}